export type JsonLdSchema = Record<string, unknown>;

const SITE_NAME = 'Parksy';
const SITE_URL = 'https://parksy.rent';
const DEFAULT_DESCRIPTION =
  "India's free crowdsourced vehicle parking map. Find, list, and compare real parking prices across India. No signup. No brokerage.";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og/default.png`;

export interface SeoMeta {
  title: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: 'website' | 'article' | 'place';
  noindex?: boolean;
  hreflang?: HreflangMap;
  publishedTime?: string;
  modifiedTime?: string;
}

export type HreflangMap = Record<string, string>;

export const SITE = {
  name: SITE_NAME,
  url: SITE_URL,
  description: DEFAULT_DESCRIPTION,
  ogImage: DEFAULT_OG_IMAGE,
  twitterHandle: '@parksy',
  locale: 'en_IN',
} as const;

export function buildCanonical(path: string): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${clean}`;
}

export function buildOgImage(name: string): string {
  return `${SITE_URL}/og/${name}.png`;
}
